<mat-label>
 <b> {{ fullDate | date: 'EEEE' }}, </b>
 <span>{{ fullDate  | date : 'mediumDate'}}</span>
</mat-label>
